<ng-container *ngIf="(isLoading | async); else contentLoading">
    <div class="component-progress-icon loading background-opacity-custom"></div>
    <div class="component-progress-icon loading fixed">
        <div class="spinner-wrapper">
          <dc-ui-image-wrapper>
            <picture>
              <img
                src="{{ spinnerImg }}"
                width="70"
                height="70"
                alt="loading"
              />
            </picture>
          </dc-ui-image-wrapper>
        </div>
    </div>
</ng-container>
<ng-template #contentLoading>
    <div class="component-progress-icon loading" [hidden]="!(isContentLoading | async)"
        [ngClass]="{ 'background-opacity': !hasLoadingImg, 'fixed': hasLoadingImg }">
        <div class="spinner-wrapper" *ngIf="hasLoadingImg">
          <dc-ui-image-wrapper>
            <picture>
              <img
                src="{{ spinnerImg }}"
                width="70"
                height="70"
                alt="loading"
              />
            </picture>
          </dc-ui-image-wrapper>
        </div>
    </div>
</ng-template>
